'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from '@/components/ui/select'
import { useCurrency } from '@/lib/currency-context'
import { ChevronDown } from 'lucide-react'

export function CurrencySelector() {
  const { currency, setCurrency, getCurrencySymbol } = useCurrency()
  const [isOpen, setIsOpen] = useState(false)

  const currencies = [
    { code: 'USD', symbol: '$', name: 'US Dollar' },
    { code: 'EUR', symbol: '€', name: 'Euro' },
    { code: 'GBP', symbol: '£', name: 'British Pound' },
  ]

  return (
    <div className="relative">
      <Select value={currency} onValueChange={(value: 'USD' | 'EUR' | 'GBP') => setCurrency(value)}>
        <SelectTrigger className="w-20 h-8 text-sm border-slate-300 focus:border-[#518BC4] focus:ring-[#518BC4]">
          <SelectValue>
            <span className="flex items-center gap-1">
              {getCurrencySymbol()}
              <span className="text-xs">{currency}</span>
            </span>
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {currencies.map((curr) => (
            <SelectItem key={curr.code} value={curr.code}>
              <span className="flex items-center gap-2">
                <span>{curr.symbol}</span>
                <span>{curr.code}</span>
                <span className="text-xs text-slate-500">- {curr.name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
